import {
  colorCss,
  FontProps,
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'

export interface LineItemLabelUiProps extends FontProps {
  lineHeight?: number
  mobileLineHeight?: number
}

export const LineItemLabel = styled.span<LineItemLabelUiProps>`
  ${colorCss}
  ${fontCss}
  ${lineHeightCss}

  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileLineHeightCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileLineHeightCss}
    `}

`
